import { Component, Input, OnInit, Injector } from '@angular/core';
import { TableAbstractComponent } from '../../../../common-page-components/classes/table-abstract-component';
import { FilterAthletesService } from '../../../../athletes/services/filter-athletes.service';
import { FiltersAthleteGeneralService } from 'src/app/athlete/services/filters-athlete-general.service';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'app-athlete-olympic-panel',
  templateUrl: './athlete-olympic-panel.component.html',
  styleUrls: ['./athlete-olympic-panel.component.scss']
})
export class AthleteOlympicPanelComponent extends TableAbstractComponent implements OnInit {

  /**
   * The input for show the data of the olympic/paralympic/youth.
   *
   * @memberof AthleteOlympicPanelComponent
   */
  @Input() olympic_data;

  /**
   * The title of the panel.
   *
   * @type {string}
   * @memberof AthleteOlympicPanelComponent
   */
  @Input() title: string;

  /**
   * The title of the panel in its short version.
   *
   * @type {string}
   * @memberof AthleteOlympicPanelComponent
   */
  @Input() short_title: string;

  /**
   * A internal variable for allow the process of the data adjusted to table requirements.
   *
   * @memberof AthleteOlympicPanelComponent
   */
  allDataProcess: Array<any>;

  /**
   * The headers into the table.
   *
   * @memberof AthleteOlympicPanelComponent
   */
  headers = [
    { name: 'Edition', isSortable: true, sortProperty: 'EDITION' },
    { name: 'Event', isSortable: true, sortProperty: 'EVENT' },
    { name: 'Result', isSortable: true, sortProperty: 'RESULT' },
  ];
  constructor(injector: Injector, athlete_service: FiltersAthleteGeneralService) {
    super(injector, athlete_service, athlete_service.athleteDetailStore)
  }

  /**
   * Method for process the data for show in table properly.
   *
   * @param {Array<any>} array The array of athlete olympics.
   * @param {string} type The type (Mixed, Team, Individual)
   * @returns
   * @memberof AthleteOlympicPanelComponent
   */
  processData(array: Array<any>, type: string) {
    // Filter details by type.
    // @TODO: Is Array.from/array) really needed? .filter already creates a shallow copy of the array.
    return Array.from(array)
      .filter(value => value.Details.findIndex(detail => detail.Events[type].length > 0) > -1)
      // Map them and assign the value of event object.
      .map(value => (value.Details.map(detail => Object.assign(detail, { 'data': value }))))
      // Get the details with the object assigned.

      .map(value => {
        // Map them with properly data.
        return value.map(detail => {
          return {
            'Event': detail[type],
            'Place': detail.Place,
            'Year': detail.Year,
            'Event_data': detail['data'],
            'Type': type
          };
        })
      })
  }

  /**
   * {@inheritdoc}
   *
   * @memberof AthleteOlympicPanelComponent
   */
  ngOnInit() {
    this.subscriptions.push(
      this.filter_service.orderValue.pipe(
        filter(value => value.sortingType == null),
        tap(() => this.changeSort('EDITION'))
      ).subscribe()
    );
    // In the return of processData we got an Array of Arrays, so we have to flatten twice.
    this.allDataProcess = [].concat.apply([], [].concat.apply([], [
      this.processData(this.olympic_data, 'Individual'),
      this.processData(this.olympic_data, 'Team'),
      this.processData(this.olympic_data, 'Mixed')
    ]))
      // Filter values that doesn't have rank.
      .filter(value => value.Event['Rnk'] != undefined);
  }



}
